import { parseAmount } from "../utils.js";
export function mapPreFilledTaxInfoToIncome(taxInfo, customerId) {
    const errors = [];
    const warnings = [];
    const sections = {};
    if (taxInfo.incomes.workIncomes?.length > 0) {
        sections.loondienst = taxInfo.incomes.workIncomes.map((workIncome) => ({
            id: `loondienst-${globalThis.crypto.randomUUID()}`,
            sectionKey: "loondienst",
            values: {
                employerName: workIncome.employer,
                salaryPeriod: "jaar",
                grossSalary: parseAmount(workIncome.salary.amount),
                percentageForToetsinkomen: 1,
                calculationMethod: "brutoJaarsalaris",
                uwvToetsinkomen: parseAmount(workIncome.salary.amount),
            },
        }));
    }
    if (taxInfo.incomes.benefits?.length > 0) {
        sections.uitkering = taxInfo.incomes.benefits.map((benefit) => ({
            id: `uitkering-${globalThis.crypto.randomUUID()}`,
            sectionKey: "uitkering",
            values: {
                uitkeringType: "02 Bijstand",
                grossYearlyBenefit: parseAmount(benefit.amount.amount),
                percentageCounted: 1,
            },
        }));
    }
    if (taxInfo.incomes.foreignBenefits?.length > 0) {
        sections.overig = taxInfo.incomes.foreignBenefits.map((foreignBenefit) => ({
            id: `overig-${globalThis.crypto.randomUUID()}`,
            sectionKey: "overig",
            values: {
                source: "99 Anders",
                description: `Foreign benefit from ${foreignBenefit.country}`,
                grossYearlyPayment: parseAmount(foreignBenefit.amount.amount),
                percentageCounted: 1,
            },
        }));
    }
    const income = {
        customerId,
        sections,
    };
    return { income, errors, warnings };
}
export function mapPreFilledTaxInfoToAssets(taxInfo, customerId) {
    const errors = [];
    const warnings = [];
    const sections = {};
    if (taxInfo.assets.bankAccounts?.length > 0) {
        sections.savingsAccount = taxInfo.assets.bankAccounts.map((bankAccount) => ({
            id: `savings-${globalThis.crypto.randomUUID()}`,
            sectionKey: "savingsAccount",
            values: {
                bank: bankAccount.accountName,
                currentBalance: parseAmount(bankAccount.amount.amount),
            },
        }));
    }
    if (taxInfo.assets.securities?.length > 0) {
        sections.investmentAccount = taxInfo.assets.securities.map((security) => ({
            id: `investment-${globalThis.crypto.randomUUID()}`,
            sectionKey: "investmentAccount",
            values: {
                company: security.bankName,
                currentBalance: parseAmount(security.amount.amount),
            },
        }));
    }
    const otherAssets = [];
    if (taxInfo.assets.insuredCapitals?.length > 0) {
        otherAssets.push(...taxInfo.assets.insuredCapitals.map((insuredCapital) => ({
            id: `other-${globalThis.crypto.randomUUID()}`,
            sectionKey: "other",
            values: {
                description: `Verzekerd kapitaal - Polis ${insuredCapital.insurancePolicyNumber}`,
                currentBalance: parseAmount(insuredCapital.insuredAmount.amount),
            },
        })));
    }
    if (taxInfo.assets.deposits?.length > 0) {
        otherAssets.push(...taxInfo.assets.deposits.map((deposit) => ({
            id: `other-${globalThis.crypto.randomUUID()}`,
            sectionKey: "other",
            values: {
                description: `Deposito - Rekening ${deposit.depositPolicyNumber}`,
                currentBalance: parseAmount(deposit.amount.amount),
            },
        })));
    }
    if (otherAssets.length > 0) {
        sections.other = otherAssets;
    }
    const assets = {
        customerId,
        sections,
    };
    return { assets, errors, warnings };
}
export function mapPreFilledTaxInfoToLiabilities(taxInfo, customerId) {
    const errors = [];
    const warnings = [];
    const sections = {};
    if (taxInfo.debts?.length > 0) {
        const personalLoans = [];
        const revolvingCredits = [];
        for (const debt of taxInfo.debts) {
            if (debt.isMortgage) {
                continue;
            }
            if (debt.bankAccountType?.toLowerCase().includes("revolving") ||
                debt.bankAccountType?.toLowerCase().includes("credit")) {
                revolvingCredits.push({
                    id: `revolving-${globalThis.crypto.randomUUID()}`,
                    sectionKey: "revolvingCredit",
                    values: {
                        company: debt.bankProductName,
                        creditLimit: parseAmount(debt.initialAmount.amount),
                        currentBalance: parseAmount(debt.finalAmount.amount),
                    },
                });
            }
            else {
                personalLoans.push({
                    id: `personal-${globalThis.crypto.randomUUID()}`,
                    sectionKey: "personalLoan",
                    values: {
                        company: debt.bankProductName,
                        principalAmount: parseAmount(debt.initialAmount.amount),
                        currentBalance: parseAmount(debt.finalAmount.amount),
                    },
                });
            }
        }
        if (personalLoans.length > 0) {
            sections.personalLoan = personalLoans;
        }
        if (revolvingCredits.length > 0) {
            sections.revolvingCredit = revolvingCredits;
        }
    }
    const liabilities = {
        customerId,
        sections,
    };
    return { liabilities, errors, warnings };
}
